// 掲載書類詳細
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import { handleBrowserBack } from '../../../BrowserBack';
import { http_status_code_list, maintenance_type } from '../../../Const';
import Maintenance from '../../../molecules/Maintenance';
import LoadingModal from '../../../molecules/LoadingModal';
import StaffNavbar from '../../../molecules/StaffNavbar';
import axios from '../../../axios';

interface DisplayedDocument {
  id: number;
  ja_name: string;
  type_name: string;
  type: string;
  subject: string;
  file_name: string;
  description: string;
  start_date: string;
  end_date: string;
}

const DisplayedDocumentDetail: React.FC = () => {
  const [is_loading, setIsLoading] = useState(false); // ローディング画面表示状態
  const [displayed_documet, setDisplayedDocument] = useState<DisplayedDocument>();
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const id = url_params.get('id');

  // グローバルナビゲーション表示用
  const [role, setRole] = useState('');
  const [has_loan_aproval_system, setHasLoanAprovalSystem] = useState(false);
  // 組織区分コードの取得
  const node = document.getElementById('displayed-document-detail');

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    getDisplayedDocument();
    // グローバルナビゲーション表示用
    setUserRole();
  }, []);

  /**
   * idから該当レコード取得
   * @return Promise<void>
   */
  const getDisplayedDocument = async (): Promise<void> => {
    //ローディング表示
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_displayed_document`,
        {
          params: {
            id: id,
          },
        }
      );
      if (response.data.result) {
        setDisplayedDocument(response.data.list);
      } else {
        console.error(response.data.message);
        alert(response.data.message);
      }
    } catch (error) {
      console.error(error.message);
      alert(error.response.data.message);
    }
    //ローディング非表示
    setIsLoading(false);
  };

  /**
   * 掲載書類のダウンロード
   *
   * @param id 該当ファイルの一意の値
   * @param file_name ファイル名
   */
  const downloadFile = (id: number, file_name: string) => {
    setIsLoading(true);
    try {
      //ファイルをダウンロードする。
      const url = `${location.origin}${process.env.MIX_MOCK_URL}/api/download_displayed_detail_document?id=${id}`;
      const self_download_link = document.createElement('a');
      document.body.appendChild(self_download_link);
      self_download_link.download = `${file_name}`;
      self_download_link.href = url;
      self_download_link.click();
      self_download_link.remove();
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      if (error.response.status === http_status_code_list.unauthorized) {
        // セッション切れの場合はログイン画面に遷移
        location.replace(error.response.data.url);
        return;
      }
      alert('システムエラーが発生しました');
    }
    setIsLoading(false);
  };

  // ロールを設定する
  const setUserRole = () => {
    if (node === null) {
      // nodeが正しく取得できない場合は空文字とする
      setRole('');
      setHasLoanAprovalSystem(false);
      return;
    }

    // ロール名をセット
    setRole(node.dataset.role as string);

    // 融資稟議システム導入済みフラグをセット
    if ((node.dataset.has_loan_aproval_system as string) === '1') {
      setHasLoanAprovalSystem(true);
    } else {
      setHasLoanAprovalSystem(false);
    }
  };

  return (
    <>
      <StaffNavbar user_role={role} has_loan_aproval_system={has_loan_aproval_system} />
      <Maintenance active={maintenance_type.displayed_documents}>
        <div className="page-title">掲載書類詳細</div>
        {typeof displayed_documet === 'object' ? (
          <>
            <table className="detail_table">
              <tbody>
                <tr>
                  <th>JA名</th>
                  <td>{displayed_documet.ja_name}</td>
                </tr>
                <tr>
                  <th>掲載書類</th>
                  <td>{displayed_documet.type_name}</td>
                </tr>
                <tr>
                  <th>画面表示名</th>
                  <td>{displayed_documet.subject}</td>
                </tr>
                <tr>
                  <th>ファイル名</th>
                  <td>
                    <a
                      className="btn-xl btn-download-icon"
                      onClick={() =>
                        downloadFile(displayed_documet?.id, displayed_documet?.file_name)
                      }
                    >
                      {displayed_documet.file_name}
                    </a>
                  </td>
                </tr>
                <tr>
                  <th>説明文</th>
                  <td>{displayed_documet.description}</td>
                </tr>
                <tr>
                  <th>開始日</th>
                  <td>{displayed_documet.start_date}</td>
                </tr>
                <tr>
                  <th>終了日</th>
                  <td>{displayed_documet.end_date}</td>
                </tr>
              </tbody>
            </table>
            <div className="footer-btn">
              <a
                className="btn btn-mini btn-outline-success btn-text-color"
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents`}
              >
                戻る
              </a>
              <a
                className="btn btn-mini btn-success"
                href={`${location.origin}${process.env.MIX_MOCK_URL}/maintenance/displayed_documents_edit?id=${displayed_documet.id}`}
              >
                編集
              </a>
            </div>
          </>
        ) : (
          <></>
        )}
        <LoadingModal show={is_loading} />
      </Maintenance>
    </>
  );
};
if (document.getElementById('displayed-document-detail')) {
  render(<DisplayedDocumentDetail />, document.getElementById('displayed-document-detail'));
}
